import { Trans } from '@lingui/react'
import classNames from 'classnames'
import { bool, shape } from 'prop-types'

import { PRICE_TYPES } from 'shared/consts/productTemplates'
import { getPriceForType } from 'shared/utils/productTemplateUtils'
import DiscountBadge from 'views/components/atoms/DiscountBadge'
import Price from 'views/components/atoms/Price'
import {
  getListPriceSuperScript,
  isDiscountValid,
  isListPriceGreaterThanOrEqualToRetailPrice,
  isPricePresent,
} from 'views/utils/productUtils'
import { ProductType } from 'views/utils/propTypes'
import { usePublicConfig } from 'views/utils/shopAndRuntimeConfigUtils'

const PriceInfo = ({
  product: {
    discount,
    flags: { prescriptionMedicine } = {},
    pharmaObl,
    prices,
    unitPricing,
  },
  shouldDisplayAbPrice,
}) => {
  const { discountBoundaries, superScripts } = usePublicConfig()
  const listPrice = getPriceForType(prices, PRICE_TYPES.LIST)
  const retailPrice = getPriceForType(prices, PRICE_TYPES.RETAIL)
  const isListPricePresent =
    !prescriptionMedicine &&
    isListPriceGreaterThanOrEqualToRetailPrice({ listPrice, retailPrice })
  const isRetailPricePresent = isPricePresent(retailPrice)
  const isValidDiscount = isDiscountValid(discount, discountBoundaries)

  return (
    <>
      <div
        className={classNames('l-flex', {
          'u-margin-x-small--bottom': discount > 0,
        })}
      >
        <DiscountBadge
          discount={discount}
          ellipse
          rounded
          smaller
          className="o-AlternativePriceInfo__CircleBadge u-margin-small--right u-font-weight--bold"
        >
          <span className="u-no-wrap">&minus;{discount}%</span>
        </DiscountBadge>
        {isRetailPricePresent && (
          <p
            className={classNames(
              'o-AlternativePriceInfo__price u-no-margin u-font-weight--bold',
              {
                'u-color--red': isValidDiscount,
              }
            )}
            data-qa-id="entry-price"
          >
            {shouldDisplayAbPrice && (
              <>
                <Trans id="general.label.price.from" />{' '}
              </>
            )}
            <Price {...retailPrice} />
          </p>
        )}
      </div>

      {unitPricing && (
        <p className="o-AlternativePriceInfo__unitPricing u-no-margin u-no-wrap u-color--grey">
          {unitPricing}
        </p>
      )}
      {isListPricePresent && (
        <p className="o-AlternativePriceInfo__listPrice l-flex u-no-margin">
          <Trans id="general.label.listPrice" />
          <sup>{getListPriceSuperScript({ superScripts, pharmaObl })}</sup>
          <span className="u-text-decoration--line-through u-margin-xx-small--left">
            <Price {...listPrice} />
          </span>
        </p>
      )}
    </>
  )
}

PriceInfo.propTypes = {
  product: shape(ProductType).isRequired,
  shouldDisplayAbPrice: bool,
}

PriceInfo.defaultProps = {
  shouldDisplayAbPrice: false,
}

export default PriceInfo
